import { config } from './config';

var Tawk_API = Tawk_API || {},
  Tawk_LoadStart = new Date();

async function tawktoConfig() {
  var s1 = document.createElement('script'),
    s0 = document.getElementsByTagName('script')[0];
  s1.async = true;
  s1.src = `https://embed.tawk.to/63db9189474251287911136f/1go8r10o9`;
  s1.charset = 'UTF-8';
  s1.setAttribute('crossorigin', '*');
  s0.parentNode.insertBefore(s1, s0);

  //   const franchiseeId = localStorage.getItem('franchisee') || null;
  //   let api = franchiseeId
  //     ? `${config?.baseUrl}${config?.version}/chatConfig/new?adminType=CA&franchiseeId=${franchiseeId}&limit=1&active=true`
  //     : `${config?.baseUrl}${config?.version}/chatConfig/new?adminType=SA&limit=1&active=true`;
  //   // ? `${config?.baseUrl}${config?.version}/chatConfig?adminType=CA&franchiseeId=${franchiseeId}&limit=1&active=true`
  //   // : `${config?.baseUrl}${config?.version}/chatConfig?adminType=SA&limit=1&active=true`;

  //   fetch(api, {
  //     method: 'get',
  //     headers: { 'Content-Type': 'application/json' },
  //   })
  //     .then((response) => response.json())
  //     .then((res) => {
  //       if (res.data[0]) {
  //         const { propertyId, chatId } = res.data[0];

  //         if (propertyId && chatId) {
  //           var s1 = document.createElement('script'),
  //             s0 = document.getElementsByTagName('script')[0];
  //           s1.async = true;
  //           s1.src = `https://embed.tawk.to/632d3b2b37898912e96ad10f/1gdkau9kd`;
  //           s1.charset = 'UTF-8';
  //           s1.setAttribute('crossorigin', '*');
  //           s0.parentNode.insertBefore(s1, s0);
  //         }
  //       }
  //     })
  //     .catch((error) => console.error('Error:', error));
}

export default tawktoConfig;
